// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__28FYb","overflowing":"ReadFullNote_overflowing__1xW3e"};